import { initHeaderActiveNav, initHeaderCTA } from '../common/header.js';

document.addEventListener('DOMContentLoaded', () => {
	initHeaderActiveNav();
	initHeaderCTA();
});
